import React, { useState } from 'react';
import remove from "../assets/icons/closeRed.svg";

const CustomFileInput = ({ fileToUpload, label = "Select Document...", onFileChange }) => {
  const [fileName, setFileName] = useState('');
  const [preview, setPreview] = useState(null); 

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      if (fileToUpload !== "doc" && file.type.startsWith('image/')) {
        setPreview(URL.createObjectURL(file));
      } else {
        setPreview(null);
      }
    }
    if (onFileChange) {
      onFileChange(event.target.files);
    }
  };

  const handleFileDelete = () => {
    setFileName('');
    setPreview(null);
    if (onFileChange) {
      onFileChange(null);
    }
  };

  return (
    <div>
      {fileToUpload === "doc" ? (
        <div className='relative'>
          <label>
            <input
              type="file"
              accept="*/*"
              onChange={handleFileChange}
              className="hidden"
            />
            <button
              className="bg-white border py-4 ps-4 pe-10 text-start rounded w-full text-sm text-secondary hover:border-brandGreen/50 truncate"
              onClick={(e) => {
                e.preventDefault();
                e.target.previousSibling.click();
              }}
            >
              {fileName ? fileName : label}
            </button>
          </label>
          {fileName && (
            <div className=" absolute top-0 h-full w-full flex items-center justify-end pe-4" onClick={handleFileDelete}>
                <img src={remove} alt="" className='h-4 cursor-pointer' />
            </div>
          )}
        </div>
      ) : (
        <div>
          {preview && (
            <div className="mb-6">
              <img
                src={preview}
                alt="Preview"
                className="w-full aspect-video object-cover rounded"
              />
            </div>
          )}
          <label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="hidden"
            />
            <button
              className="bg-white border py-4 px-8 rounded w-full text-sm text-secondary hover:border-brandGreen/50"
              onClick={(e) => {
                e.preventDefault();
                e.target.previousSibling.click();
              }}
            >
              {fileName ? "Change image..." : label}
            </button>
          </label>
        </div>
      )}
    </div>
  );
};

export default CustomFileInput;
